import { useEffect } from 'react';
import { objType }   from 'types';

const useRecorddError = (
    data:             objType,
    content:          objType,
    recErr:           boolean, 
    recordErrOnce:    boolean, 
    showLoader:       boolean,
    goToVideoOnce:    boolean, 
    setRecErr:        (val: boolean) => void,
    setRecordErrOnce: (val: boolean) => void,
) => {

   useEffect(() => {
    import("functions/record_error").then(func => {
        func.recordError(data, content, recErr, recordErrOnce, showLoader, goToVideoOnce, setRecErr, setRecordErrOnce);
    });
   },[data, content, recErr, goToVideoOnce, recordErrOnce, showLoader, setRecErr, setRecordErrOnce])
    
}

export default useRecorddError